import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-PTypeGroupsModal" */'@modals/partials/PTypeGroups'));
